import React from "react";

export const GoogleStoreBrandLarge = () => {
  return (
    <svg
      width="149"
      height="44"
      viewBox="0 0 149 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="147.5" height="43" rx="4.5" fill="black" />
      <path
        d="M74.9479 23.9264C72.3607 23.9264 70.252 25.8943 70.252 28.6047C70.252 31.2986 72.3607 33.283 74.9479 33.283C77.5362 33.283 79.6449 31.2986 79.6449 28.6047C79.6438 25.8943 77.5351 23.9264 74.9479 23.9264ZM74.9479 31.4416C73.53 31.4416 72.3079 30.2723 72.3079 28.6058C72.3079 26.9217 73.5311 25.77 74.9479 25.77C76.3658 25.77 77.5879 26.9217 77.5879 28.6058C77.5879 30.2712 76.3658 31.4416 74.9479 31.4416ZM64.7025 23.9264C62.1153 23.9264 60.0066 25.8943 60.0066 28.6047C60.0066 31.2986 62.1153 33.283 64.7025 33.283C67.2908 33.283 69.3995 31.2986 69.3995 28.6047C69.3995 25.8943 67.2908 23.9264 64.7025 23.9264ZM64.7025 31.4416C63.2846 31.4416 62.0625 30.2723 62.0625 28.6058C62.0625 26.9217 63.2857 25.77 64.7025 25.77C66.1204 25.77 67.3425 26.9217 67.3425 28.6058C67.3436 30.2712 66.1204 31.4416 64.7025 31.4416ZM52.5167 25.363V27.3474H57.2665C57.1246 28.4639 56.7528 29.279 56.1852 29.8455C55.4944 30.5363 54.4131 31.2986 52.5167 31.2986C49.5929 31.2986 47.3071 28.9413 47.3071 26.0175C47.3071 23.0937 49.5929 20.7364 52.5167 20.7364C54.0941 20.7364 55.2458 21.3568 56.0961 22.1543L57.4964 20.754C56.3084 19.6199 54.7321 18.752 52.5167 18.752C48.5116 18.752 45.1445 22.0124 45.1445 26.0175C45.1445 30.0226 48.5116 33.283 52.5167 33.283C54.6782 33.283 56.3095 32.5735 57.5844 31.2447C58.8956 29.9335 59.3037 28.0899 59.3037 26.6016C59.3037 26.1418 59.2685 25.7161 59.197 25.3619H52.5167V25.363ZM102.356 26.9041C101.966 25.8591 100.778 23.9264 98.3504 23.9264C95.9403 23.9264 93.9372 25.8228 93.9372 28.6047C93.9372 31.2271 95.9227 33.283 98.5803 33.283C100.724 33.283 101.965 31.9718 102.48 31.2095L100.885 30.1458C100.354 30.9257 99.6264 31.4394 98.5803 31.4394C97.5353 31.4394 96.7906 30.9609 96.3121 30.0215L102.568 27.4343L102.356 26.9041ZM95.9755 28.4639C95.9227 26.6555 97.3758 25.7348 98.4219 25.7348C99.237 25.7348 99.9278 26.1429 100.159 26.727L95.9755 28.4639ZM90.8902 33.0003H92.945V19.2492H90.8902V33.0003ZM87.522 24.9725H87.4516C86.9907 24.4225 86.1041 23.9264 84.9887 23.9264C82.649 23.9264 80.5051 25.9823 80.5051 28.6234C80.5051 31.2458 82.649 33.2841 84.9887 33.2841C86.1052 33.2841 86.9907 32.788 87.4516 32.2215H87.522V32.8947C87.522 34.6844 86.565 35.6414 85.0239 35.6414C83.7655 35.6414 82.9856 34.7383 82.6666 33.976L80.8769 34.7207C81.3906 35.9604 82.7546 37.485 85.0239 37.485C87.434 37.485 89.4723 36.0671 89.4723 32.6109V24.2113H87.5231V24.9725H87.522ZM85.1658 31.4416C83.7479 31.4416 82.561 30.2536 82.561 28.6234C82.561 26.9745 83.7479 25.77 85.1658 25.77C86.565 25.77 87.6639 26.9745 87.6639 28.6234C87.6639 30.2536 86.565 31.4416 85.1658 31.4416ZM111.985 19.2492H107.067V33.0003H109.118V27.7907H111.984C114.259 27.7907 116.496 26.144 116.496 23.5205C116.496 20.897 114.26 19.2492 111.985 19.2492ZM112.038 25.8767H109.118V21.1632H112.038C113.572 21.1632 114.443 22.4337 114.443 23.5205C114.443 24.5853 113.572 25.8767 112.038 25.8767ZM124.723 23.9022C123.237 23.9022 121.698 24.5567 121.061 26.0076L122.883 26.7677C123.272 26.0076 123.998 25.759 124.758 25.759C125.82 25.759 126.899 26.3959 126.916 27.5278V27.6697C126.545 27.4574 125.748 27.1395 124.776 27.1395C122.812 27.1395 120.812 28.2186 120.812 30.2349C120.812 32.0752 122.423 33.2599 124.227 33.2599C125.606 33.2599 126.367 32.6406 126.845 31.9146H126.915V32.9761H128.897V27.7038C128.899 25.264 127.075 23.9022 124.723 23.9022ZM124.474 31.4383C123.803 31.4383 122.865 31.1017 122.865 30.2701C122.865 29.2086 124.033 28.8016 125.042 28.8016C125.943 28.8016 126.369 28.9963 126.916 29.2614C126.757 30.5363 125.66 31.4383 124.474 31.4383ZM136.116 24.2025L133.763 30.1645H133.692L131.25 24.2025H129.039L132.701 32.535L130.613 37.1704H132.754L138.398 24.2025H136.116ZM117.629 33.0003H119.681V19.2492H117.629V33.0003Z"
        fill="white"
      />
      <path
        d="M52.1609 11.2673C52.1609 12.1891 51.8881 12.9228 51.3414 13.4706C50.721 14.1218 49.9114 14.4474 48.917 14.4474C47.9644 14.4474 47.1537 14.1174 46.4882 13.4574C45.8216 12.7963 45.4883 11.9779 45.4883 11.0011C45.4883 10.0232 45.8216 9.20476 46.4882 8.54476C47.1537 7.88366 47.9644 7.55366 48.917 7.55366C49.39 7.55366 49.8421 7.64606 50.2711 7.82976C50.7012 8.01456 51.0455 8.25986 51.3029 8.56676L50.7232 9.14756C50.2865 8.62506 49.6848 8.36436 48.9159 8.36436C48.2207 8.36436 47.6201 8.60856 47.113 9.09696C46.6059 9.58536 46.3529 10.2201 46.3529 11C46.3529 11.7799 46.6059 12.4146 47.113 12.903C47.6201 13.3914 48.2207 13.6356 48.9159 13.6356C49.6529 13.6356 50.2678 13.3903 50.7595 12.8986C51.0785 12.5785 51.2633 12.133 51.3128 11.5621H48.9159V10.769H52.1136C52.1466 10.9417 52.1609 11.1078 52.1609 11.2673Z"
        fill="white"
      />
      <path
        d="M57.232 8.51072H54.2268V10.6029H56.9372V11.396H54.2268V13.4882H57.232V14.3H53.3787V7.70002H57.232V8.51072Z"
        fill="white"
      />
      <path
        d="M60.808 14.3H59.9599V8.51072H58.1163V7.70002H62.6516V8.51072H60.808V14.3Z"
        fill="white"
      />
      <path d="M65.9328 14.3V7.70002H66.7809V14.3H65.9328Z" fill="white" />
      <path
        d="M70.542 14.3H69.6939V8.51072H67.8503V7.70002H72.3856V8.51072H70.542V14.3Z"
        fill="white"
      />
      <path
        d="M80.9708 13.4475C80.3218 14.1141 79.5155 14.4474 78.5508 14.4474C77.5861 14.4474 76.7798 14.1141 76.1319 13.4475C75.4829 12.7809 75.1595 11.9647 75.1595 11C75.1595 10.0353 75.4829 9.21911 76.1319 8.55251C76.7798 7.88591 77.5861 7.55151 78.5508 7.55151C79.51 7.55151 80.3153 7.88701 80.9664 8.55691C81.6176 9.22681 81.9432 10.0408 81.9432 11C81.9432 11.9647 81.6187 12.7809 80.9708 13.4475ZM76.7578 12.8942C77.2462 13.3892 77.8435 13.6356 78.5508 13.6356C79.2581 13.6356 79.8565 13.3881 80.3438 12.8942C80.8322 12.3992 81.0775 11.7678 81.0775 11C81.0775 10.2322 80.8322 9.60081 80.3438 9.10581C79.8565 8.61081 79.2581 8.36441 78.5508 8.36441C77.8435 8.36441 77.2462 8.61191 76.7578 9.10581C76.2705 9.60081 76.0252 10.2322 76.0252 11C76.0252 11.7678 76.2705 12.3992 76.7578 12.8942Z"
        fill="white"
      />
      <path
        d="M83.1335 14.3V7.70002H84.1653L87.3729 12.8337H87.4092L87.3729 11.5621V7.70002H88.221V14.3H87.3355L83.9794 8.91663H83.9431L83.9794 10.1882V14.3H83.1335Z"
        fill="white"
      />
      <path
        d="M52.1609 11.2673C52.1609 12.1891 51.8881 12.9228 51.3414 13.4706C50.721 14.1218 49.9114 14.4474 48.917 14.4474C47.9644 14.4474 47.1537 14.1174 46.4882 13.4574C45.8216 12.7963 45.4883 11.9779 45.4883 11.0011C45.4883 10.0232 45.8216 9.20476 46.4882 8.54476C47.1537 7.88366 47.9644 7.55366 48.917 7.55366C49.39 7.55366 49.8421 7.64606 50.2711 7.82976C50.7012 8.01456 51.0455 8.25986 51.3029 8.56676L50.7232 9.14756C50.2865 8.62506 49.6848 8.36436 48.9159 8.36436C48.2207 8.36436 47.6201 8.60856 47.113 9.09696C46.6059 9.58536 46.3529 10.2201 46.3529 11C46.3529 11.7799 46.6059 12.4146 47.113 12.903C47.6201 13.3914 48.2207 13.6356 48.9159 13.6356C49.6529 13.6356 50.2678 13.3903 50.7595 12.8986C51.0785 12.5785 51.2633 12.133 51.3128 11.5621H48.9159V10.769H52.1136C52.1466 10.9417 52.1609 11.1078 52.1609 11.2673Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M57.232 8.51072H54.2268V10.6029H56.9372V11.396H54.2268V13.4882H57.232V14.3H53.3787V7.70002H57.232V8.51072Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M60.808 14.3H59.9599V8.51072H58.1163V7.70002H62.6516V8.51072H60.808V14.3Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M65.9328 14.3V7.70002H66.7809V14.3H65.9328Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M70.542 14.3H69.6939V8.51072H67.8503V7.70002H72.3856V8.51072H70.542V14.3Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M80.9708 13.4475C80.3218 14.1141 79.5155 14.4474 78.5508 14.4474C77.5861 14.4474 76.7798 14.1141 76.1319 13.4475C75.4829 12.7809 75.1595 11.9647 75.1595 11C75.1595 10.0353 75.4829 9.21911 76.1319 8.55251C76.7798 7.88591 77.5861 7.55151 78.5508 7.55151C79.51 7.55151 80.3153 7.88701 80.9664 8.55691C81.6176 9.22681 81.9432 10.0408 81.9432 11C81.9432 11.9647 81.6187 12.7809 80.9708 13.4475ZM76.7578 12.8942C77.2462 13.3892 77.8435 13.6356 78.5508 13.6356C79.2581 13.6356 79.8565 13.3881 80.3438 12.8942C80.8322 12.3992 81.0775 11.7678 81.0775 11C81.0775 10.2322 80.8322 9.60081 80.3438 9.10581C79.8565 8.61081 79.2581 8.36441 78.5508 8.36441C77.8435 8.36441 77.2462 8.61191 76.7578 9.10581C76.2705 9.60081 76.0252 10.2322 76.0252 11C76.0252 11.7678 76.2705 12.3992 76.7578 12.8942Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M83.1335 14.3V7.70002H84.1653L87.3729 12.8337H87.4092L87.3729 11.5621V7.70002H88.221V14.3H87.3355L83.9794 8.91663H83.9431L83.9794 10.1882V14.3H83.1335Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <g filter="url(#filter0_ii_2136_37677)">
        <path
          d="M11.4781 8.29173C11.158 8.63053 10.9687 9.15633 10.9687 9.83723V34.1648C10.9687 34.8468 11.158 35.3715 11.4781 35.7103L11.5595 35.7895L25.1874 22.1616V22.001V21.8404L11.5595 8.21143L11.4781 8.29173Z"
          fill="url(#paint0_linear_2136_37677)"
        />
        <path
          d="M29.7294 26.7057L25.1875 22.1616V22.001V21.8404L29.7305 17.2974L29.8328 17.3557L35.2151 20.4137C36.7518 21.2871 36.7518 22.716 35.2151 23.5905L29.8328 26.6485L29.7294 26.7057Z"
          fill="url(#paint1_linear_2136_37677)"
        />
        <g filter="url(#filter1_i_2136_37677)">
          <path
            d="M29.8312 26.6474L25.1848 22.001L11.4766 35.7103C11.9826 36.2471 12.8197 36.3131 13.7624 35.7785L29.8312 26.6474Z"
            fill="url(#paint2_linear_2136_37677)"
          />
        </g>
        <path
          d="M29.8312 17.3547L13.7624 8.22466C12.8197 7.68896 11.9826 7.75606 11.4766 8.29286L25.1859 22.0022L29.8312 17.3547Z"
          fill="url(#paint3_linear_2136_37677)"
        />
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="147.5"
        height="43"
        rx="4.5"
        stroke="#A6A6A6"
      />
      <defs>
        <filter
          id="filter0_ii_2136_37677"
          x="10.9688"
          y="7.85498"
          width="25.3984"
          height="28.2927"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2136_37677"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_2136_37677"
            result="effect2_innerShadow_2136_37677"
          />
        </filter>
        <filter
          id="filter1_i_2136_37677"
          x="11.4766"
          y="22.001"
          width="18.3555"
          height="14.1467"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2136_37677"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2136_37677"
          x1="23.9793"
          y1="9.57983"
          x2="5.51913"
          y2="28.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2136_37677"
          x1="37.2154"
          y1="22.001"
          x2="10.6"
          y2="22.001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2136_37677"
          x1="27.3079"
          y1="24.5243"
          x2="2.27353"
          y2="49.5586"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2136_37677"
          x1="8.0241"
          y1="0.194443"
          x2="19.2026"
          y2="11.373"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};
